import React from "react";

import "./index.css";
import { I18nextProvider } from "react-i18next";
import App from "./App";
import "../src/assets/styles/styles.scss";
import ReactDOM from "react-dom";

import i18n from "./i18n";

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>,
  document.getElementById("root")
);
